import { useScrollEdges } from '../../../../../../../hooks/useScrollEdges';
import useGeneralSettingsStore from '../../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { getMediaAspectRatio } from '../../../../../../../utils/getMediaAspectRatio';
import { RACHEL_PRODUCT_CARD_WIDTH } from '../RachelProductCard/rachelProductCard.styles';

const CARDS_PER_SCROLL = 3;
const SCROLL_DISTANCE = RACHEL_PRODUCT_CARD_WIDTH * CARDS_PER_SCROLL;
const PERCENT = 100;

export const useProductCardsCarousel = () => {
  const scrollEdges = useScrollEdges();
  const mediaFormat = useGeneralSettingsStore((state) => state.generalSettings.mediaFormat);

  const mediaHeight =
    (RACHEL_PRODUCT_CARD_WIDTH * Number.parseFloat(getMediaAspectRatio(mediaFormat))) / PERCENT;

  const scrollByCards = (direction: -1 | 1) => {
    scrollEdges.containerRef.current?.scrollBy({
      left: direction * SCROLL_DISTANCE,
      behavior: 'smooth',
    });
  };

  return {
    ...scrollEdges,
    navTop: mediaHeight / 2,
    scrollPrevious: () => scrollByCards(-1),
    scrollNext: () => scrollByCards(1),
  };
};
